import { get, post, del, put, patch } from "_shared/request";
import { getEnv } from "../../../utils/constants";

export const getAllResources = async (teamId) => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/resourcepage/getAllDepartments?teamid=${teamId}`,
  });

  return data;
};

export const getIsAdminDepartment = async (selectedResource, user) => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/resourcepage/is-user-department-admin?departmentId=${
      selectedResource?.key
    }&teamMemberId=${user?.TeamId}`,
  });

  return data;
};

export const getNonadminSelectedResource = async (selectedResource) => {
  const { data } = await get({
    url: `${getEnv("RESOURCES_BASE_URL")}/resourcepage/getDepartment/${
      selectedResource.key
    }`,
  });

  return data;
};

export const getAdminSelectedResource = async (selectedResource) => {
  const { data } = await get({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/resource/department/${
      selectedResource.key
    }`,
  });

  return data;
};

export const getAllUserFavoriteResources = async () => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/resourcepage/GetAllUserFavoriteResources`,
  });

  return data;
};

export const getBlobUploadEndpoint = async (blobPayload) => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/admin/resource/generate-upload-file-url/${
      blobPayload.departmentId
    }?Directory=${blobPayload.directory}&Filename=${blobPayload.fileName}`,
  });

  return data;
};

export const getBlobDownloadEndpoint = async (blobPayload) => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/resourcepage/generate-download-file-url?Directory=${
      blobPayload.directory
    }&Filename=${blobPayload.fileName}`,
  });

  return data;
};

export const sortByReorder = async (payload, departmentId, parentSectionId) => {
  const res = await post({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/admin/resource/sort-documents/${parentSectionId}/${departmentId}`,
    data: payload,
  });

  return res;
};

export const addSection = async (createSectionPayload, departmentId) => {
  const res = await put({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/section/${departmentId}`,
    data: createSectionPayload,
  });

  return res;
};

export const editDepartment = async (editDepartmentPayload, departmentId) => {
  const res = await post({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/department/${departmentId}`,
    data: editDepartmentPayload,
  });

  return res;
};

export const editSection = async (editSectionPayload, departmentId) => {
  const res = await post({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/section/${departmentId}`,
    data: editSectionPayload,
  });

  return res;
};

export const deleteSection = async (payload, departmentId) => {
  const res = await post({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/section/${departmentId}`,
    data: payload,
  });

  return res;
};

export const addResource = async (createResourcePayload, departmentId) => {
  const res = await put({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/resource/${departmentId}`,
    data: createResourcePayload,
  });

  return res;
};

export const editResource = async (createResourcePayload, departmentId) => {
  const res = await patch({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/resource/${departmentId}`,
    data: createResourcePayload,
  });

  return res;
};

export const deleteResource = async (payload, departmentId) => {
  const res = await patch({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/resource/${departmentId}`,
    data: payload,
  });

  return res;
};

export const getAdminResourceDetails = async (resourceID, departmentId) => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/admin/resource/resources/${departmentId}?ResourceId=${resourceID}`,
  });

  return data;
};

export const getNonAdminResourceDetails = async (resourceID, departmentId) => {
  const { data } = await get({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/resourcepage/getResource/${resourceID}`,
  });

  return data;
};

export const favoriteResource = async (args) => {
  const payload = {
    resourceKey: args.resourceId,
    source: "TeamMember",
    sourceId: args.teamId,
  };

  const data = await post({
    url: `${getEnv("RESOURCES_BASE_URL")}/resourcepage/AddUserFavoriteResource`,
    data: payload,
  });
};

export const unfavoriteResource = async (args) => {
  const payload = {
    resourceKey: args.resourceId,
    source: "TeamMember",
    sourceId: args.teamId,
  };

  const data = await del({
    url: `${getEnv(
      "RESOURCES_BASE_URL"
    )}/resourcepage/RemoveUserFavoriteResource`,
    data: payload,
  });
};

export const addContactList = async (contactListPayload, departmentId) => {
  console.log("THIS IS CONTACT LIST PAYLOAD---", contactListPayload);

  const transformContacts = (data) => {
    return data.map((section) => {
      return {
        title: section.title,
        description: section.description,
        isActive: true,
        contactItem: section.resourceContactItems.map((item) =>
          item.teamMemberSelected?.value
            ? {
                displayText: item.teamMemberSelected.displayText,
                email: item.teamMemberSelected.email,
                teamMemberId: item.teamMemberSelected.value,
                description: item.teamMemberSelected.description,
                isActive: true,
              }
            : {
                displayText: item.displayText,
                email: item.email,
                isActive: true,
              }
        ),
      };
    });
  };

  const transformedSections = transformContacts(
    contactListPayload.contactSections
  );

  const payload = {
    ...contactListPayload,
    contactSections: transformedSections,
  };

  console.log("THIS IS PAYLOAD BEFORE LOOP---", payload);

  const res = await put({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/contact-list/${departmentId}`,
    data: payload,
  });

  // return res;
};

export const editContactList = async (contactListPayload, departmentId) => {
  console.log("THIS IS CONTACT LIST PAYLOAD---", contactListPayload);

  const transformContacts = (data) => {
    return data.map((section) => {
      return {
        title: section.title,
        description: section.description,
        ...(section.contactSectionId && {
          contactSectionId: section.contactSectionId,
        }),
        isActive: section.isActive,
        contactItem: section.resourceContactItems.map((item) => {
          const isTeamMember = !!item.teamMemberSelected?.value;

          const base = {
            isActive: item.isActive,
            ...(item.contactItemId && { contactItemId: item.contactItemId }),
          };

          if (isTeamMember) {
            return {
              ...base,
              displayText: item.teamMemberSelected.displayText,
              email: item.teamMemberSelected.email,
              teamMemberId: item.teamMemberSelected.value,
              description: item.teamMemberSelected.description,
            };
          }

          return {
            ...base,
            displayText: item.displayText,
            email: item.email,
          };
        }),
      };
    });
  };

  const transformedSections = transformContacts(
    contactListPayload.contactSections
  );

  const payload = {
    ...contactListPayload,
    contactSections: transformedSections,
  };

  console.log("THIS IS PAYLOAD BEFORE LOOP---", payload);

  const res = await patch({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/contact-list/${departmentId}`,
    data: payload,
  });
};

export const deleteContactList = async (contactListPayload, departmentId) => {
  console.log("THIS IS DELETE USEEEEE----", contactListPayload, departmentId);
  const transformContacts = (data) => {
    return data.map((section) => {
      return {
        title: section.title,
        description: section.description,
        ...(section.contactSectionId && {
          contactSectionId: section.contactSectionId,
        }),
        isActive: section.isActive,
        contactItem: section.resourceContactItems.map((item) => {
          const isTeamMember = !!item.teamMemberSelected?.value;

          const base = {
            isActive: item.isActive,
            ...(item.contactItemId && { contactItemId: item.contactItemId }),
          };

          if (isTeamMember) {
            return {
              ...base,
              displayText: item.teamMemberSelected.displayText,
              email: item.teamMemberSelected.email,
              teamMemberId: item.teamMemberSelected.value,
              description: item.teamMemberSelected.description,
            };
          }

          return {
            ...base,
            displayText: item.displayText,
            email: item.email,
          };
        }),
      };
    });
  };

  console.log("THIS SI CONTACTLISTPAYLOD delete---", contactListPayload);

  const transformedSections = transformContacts(
    contactListPayload.contactSections
  );

  const payload = {
    ...contactListPayload,
    contactSections: transformedSections,
  };

  const res = await patch({
    url: `${getEnv("RESOURCES_BASE_URL")}/admin/contact-list/${departmentId}`,
    data: payload,
  });

  return res;
};
